import { queryOptions } from "@tanstack/react-query";
import { getHttp } from "../api-client";
import { API_ENDPOINTS } from "../endpoints";
import { queryKeys } from "../queryKeys";
import type { Course, CourseModule } from "../types/course";
import { unwrapData } from "./unwrapData";

// Queries shared by the teacher dashboard, header, sidebar and MCQ screens.
export const teacherQueries = {
  profile: () =>
    queryOptions({
      queryKey: queryKeys.teacherProfile(),
      queryFn: () => getHttp().get(API_ENDPOINTS.TEACHER.PROFILE),
    }),

  courses: () =>
    queryOptions({
      queryKey: queryKeys.teacherCourses(),
      queryFn: async () => unwrapData<Course[]>(await getHttp().get(API_ENDPOINTS.TEACHER.COURSES)),
    }),

  courseModules: (courseCode: string | undefined) =>
    queryOptions({
      queryKey: queryKeys.courseModules(courseCode),
      queryFn: async (): Promise<CourseModule[]> =>
        courseCode
          ? unwrapData<CourseModule[]>(await getHttp().get(API_ENDPOINTS.TEACHER.COURSE_MODULES(courseCode)))
          : [],
    }),
};
